import ButtonIcon from "ds/components/ButtonIcon";
import useLayoutStore from "components/Layout/stores/useLayoutStore";
import { List } from "components/icons/generated";

import styles from "./styles.module.css";

const FiltersMobileTriggerButton = () => {
  const setShowFilters = useLayoutStore((state) => state.setShowFilters);

  return (
    <ButtonIcon
      size="medium"
      variant="secondary"
      onPress={() => setShowFilters(true)}
      icon={List}
      className={styles.button}
    >
      Show filters
    </ButtonIcon>
  );
};

export default FiltersMobileTriggerButton;
